import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import type {AgentChangeHandler, AgentOverrideRow} from '../../ai-chat-super-user-options.types';
import type {SuperUserPromptVariantsProps} from './super-user-prompt-variants.types';
import {WEIGHTED_PICK_VALUE} from './super-user-prompt-variants.types';
import styles from './super-user-prompt-variants.module.scss';

export function SuperUserPromptVariants({agents, onChangeAgent}: SuperUserPromptVariantsProps): ReactElement {
  return (
    <>
      <ul className={styles.variantList}>{agents.map((row) => renderVariantRow(row, onChangeAgent))}</ul>
      <Text val={window.i18next.t('pmwjs_super_user_overrides_note')} size={TextSize.XS} className={styles.variantNote} />
    </>
  );
}

function renderVariantRow(row: AgentOverrideRow, onChangeAgent: AgentChangeHandler): ReactElement {
  const activeCount = row.options.filter((option) => option.isActive).length;
  const selectId = `ai-chat-variant-${row.agentType}`;

  return (
    <li key={row.agentType} className={styles.variantRow}>
      <label htmlFor={selectId}>
        <Text val={row.agentType} size={TextSize.XS} className={styles.variantAgent} />
      </label>
      <select id={selectId} className={styles.variantField} value={row.currentAlias ?? WEIGHTED_PICK_VALUE} onChange={onChangeAgent(row.agentType)}>
        <option value={WEIGHTED_PICK_VALUE}>{`${window.i18next.t('pmwjs_variant_weighted_pick')} · ${getVariantCountLabel(activeCount)}`}</option>
        {row.options.map((option) => (
          <option key={option.idAiPrompt} value={option.alias ?? ''} disabled={!option.isActive}>
            {formatVariantOptionLabel(option.alias, option.weightPct, option.isActive)}
          </option>
        ))}
      </select>
    </li>
  );
}

function formatVariantOptionLabel(alias: string | null, weightPct: number, isActive: boolean): string {
  const label = `${alias ?? window.i18next.t('pmwjs_variant_unnamed')} · ${weightPct}%`;

  if (isActive) {
    return label;
  }

  return `${label} · ${window.i18next.t('pmwjs_variant_inactive_suffix')}`;
}

function getVariantCountLabel(count: number): string {
  if (count === 1) {
    return window.i18next.t('pmwjs_variant_count_one');
  }

  return window.i18next.t('pmwjs_variant_count_other', {count});
}
